import { compose, withBemMod } from '@bem-react/core';
import React, { ReactElement, FC } from 'react';

import {
    Player as PlayerBase,
    withTypeEther as withPlayerTypeEther,
} from 'components/Player';

import { cnStreamScreen } from '../StreamScreen.cn';
import { StreamScreenProps } from '../StreamScreen.interface';

export interface WithTypeEther {
  type?: 'ether',
}

const Player = compose(
    withPlayerTypeEther,
)(PlayerBase);

export const withTypeEther = withBemMod<WithTypeEther, StreamScreenProps>(
    cnStreamScreen(),
    { type: 'ether' },
    (StreamScreen): FC<WithTypeEther & StreamScreenProps> => (
        (props: WithTypeEther & StreamScreenProps): ReactElement => {
            const {
                etherUrl,
                playerType,
            } = props;

            const player = (
                <Player
                    className={cnStreamScreen('Player')}
                    etherUrl={etherUrl}
                    type="ether"
                    audioOnly={playerType === 'audio'}
                />
            );

            return (
                <StreamScreen
                    {...props}
                    player={player}
                />
            );
        }
    ),
);

export default withTypeEther;
